module.exports = __webpack_public_path__ + "img/coop-1.242a0246.png";